export default __webpack_public_path__ + "static/media/slider_horizontal_theme1.8d3c9a50.svg";